import { Slide } from '@/components/core/Slide';
import audioFile from './20-ai-applications.mp3';

// const autoNextDuration = 121000;
const transcript = `
  Ik zal jullie meenemen in de concrete AI-toepassingen die nu al relevant zijn voor het mkb in de 
  technieksector.

  Voorspellend onderhoud is een krachtige toepassing. Door data van machines te analyseren, kunnen we 
  storingen voorkomen nog voordat ze optreden. Dit verhoogt de betrouwbaarheid van installaties aanzienlijk.

  In de klantenservice zien we slimme oplossingen zoals chatbots en beeldherkenning. Deze kunnen snel 
  reageren op standaard klantvragen, waardoor er minder druk komt op schaarse monteurs.

  Digitale assistenten, geïntegreerd met ERP-systemen, helpen medewerkers om hun administratie snel en 
  eenvoudig af te handelen. Dit bespaart kostbare tijd.

  Een spannende ontwikkeling is het automatisch genereren van bouwtekeningen. AI kan razendsnel 
  verschillende ontwerpen maken, wat het offertetraject aanzienlijk verkort.

  In planning en logistiek zorgt AI voor slimme routeoptimalisatie. Dit bespaart niet alleen tijd en 
  brandstof, maar verhoogt ook de productiviteit van je mensen.

  Tot slot helpt AI bij kennisborging en training. Het kan de ervaring van vertrekkende experts vastleggen 
  en helpt zo bij het versnellen van kennisdeling naar nieuwe medewerkers.

  Jonathan, zal ik nu wat voorbeelden laten zien?
`;

// Jonathan: Ja dat is goed, ga je gang.

export const slide = () => {
  return (
    <Slide
      notes={`
        ${transcript}
      `}
      audio={audioFile}
      // autoNext={autoNextDuration}
      visualizer="bottom-right"
      networkBackground="full"
      transition="fade"
    >
      <div className="slide relative z-10">
        <h1 className="text-4xl font-bold mb-10">🤖 AI-toepassingen MKB</h1>
        <ul className="space-y-6 list-disc">
          <li>Voorspellend onderhoud</li>
          <li>Slimme klantenservice (chatbots)</li>
          <li>Digitale assistenten voor administratie</li>
          <li>Automatische bouwtekeningen</li>
          <li>Geavanceerde planning en logistiek</li>
          <li>Kennisborging en training</li>
        </ul>
      </div>
    </Slide>
  );
};
